import { useCallback, useEffect, useState } from "react";
import { ITask } from "../types";
import WorkTasksService from "../../../services/workTasks";

export const useFetchData = (request: any) => {
  const [data, setData] = useState<ITask[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = useCallback(
    (showLoader?: boolean) => {
      showLoader && setIsLoading(true);

      WorkTasksService.fetchAll(request)
        .then((res) => {
          setData(res);

          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    },
    [request],
  );

  useEffect(() => {
    fetchData(true);
  }, [fetchData]);

  return { data, isLoading, setData, fetchData };
};
